// component import
import DataTable from "../../common/DataTable";
// function imports
import { useTableSearch } from "../../../functions/tableSearch";

export default function GensetTable({ data }) {
  const { getColumnSearchProps } = useTableSearch();
  const tableColumns = [
    {
      title: "Phase Name",
      dataIndex: "phasename",
      key: "phasename",
      ...getColumnSearchProps("phasename"),
    },
    {
      title: "Voltage",
      dataIndex: "voltage",
      key: "voltage",
    },
    {
      title: "Current",
      dataIndex: "current",
      key: "current",
    },
    {
      title: "Power Factor",
      dataIndex: "powerfactor",
      key: "powerfactor",
    },
    {
      title: "Active Power",
      dataIndex: "activepower",
      key: "activepower",
    },
    {
      title: "Reactive Power",
      dataIndex: "reactivepower",
      key: "reactivepower",
    },
  ];

  return <DataTable table_data={data} table_column={tableColumns} />;
}
